export const initialDeviceLogsState = {
    messageLogsByDeviceId: {},
    httpLogsByDeviceId: {},
    logRequests: {},
};
